module.exports = __webpack_public_path__ + "img/logo-ranhill2.bb55ea97.svg";